module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//pet-effect_base_3.png?v=b3e1b886";